import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';

import { axiosInstance } from '../../shared/api/axios-instance';
import { Endpoints } from '../../shared/utils/endpoints-file.utils';
import { MandantDto } from '../dtos/mandant.dto';
import { MandantModel } from '../models/mandant.model';
import { mapMandatDtoToMandantModel } from '../utils/mapping.utils';

export const getMandants = createAsyncThunk<MandantModel[], void>(
  'mandant/getMandants',
  async (): Promise<MandantModel[]> => {
    const { data }: AxiosResponse<MandantDto[]> = await axiosInstance.get(
      Endpoints.GET_MANDANTS
    );

    return data.map(mapMandatDtoToMandantModel);
  }
);
